<template>
    <div class="page-section" v-c:collapsible="collapsible" :class="classes">
        <slot name="header">
            <flex class="page-section-header" v-if="title !== null || actions.length > 0">
                <slot name="title">
                    <h3>{{ title }}</h3>
                </slot>
                <slot name="actions">
                    <panel xs="wrap" space="1" class="ml-auto" v-if="actions.length > 0">
                        <btn v-for="(action, index) in actions" :key="index" v-bind="mergeActionDefaults(action)"/>
                    </panel>
                </slot>
            </flex>
        </slot>

        <loading-indicator v-if="loading"/>
        <div v-else class="page-section-content">
            <slot>
                <component :is="component" v-bind="props"/>
            </slot>
        </div>

        <btn theme="none" class="page-section-collapse" v-bind="collapseButton" @click="isOpen = !isOpen"/>
    </div>
</template>

<style lang="scss">
    .page-section {
        padding: $spacer-3;
        background-color: $white;
        box-shadow: $layout-shadow;

        &:not(:last-child) {
            margin-bottom: $spacer-2;
        }
    }
    .page-section-header {
        width: 100%;
        min-height: 32px;

        h3 {
            margin-bottom: 0;
            color: $red;
            font-size: $font-size-base;
            font-weight: bold;
            text-transform: uppercase;
        }
    }
    .page-section-content > *:last-child {
        margin-bottom: 0;
    }
    .page-section-header ~ .page-section-content {
        margin-top: $spacer-3;
    }
    .page-section-collapse {
        display: none;
        margin-top: $spacer-1;
    }

    @each $theme, $color in $theme-colors {
        .page-section-#{$theme} {
            background-color: $color;
            color: $white;
            h3 {
                color: $white;
            }
            .btn-outline-light {
                color: $white;
                border-color: $white;

                &:hover {
                    background-color: $white;
                    color: $color;
                }
            }
        }
    }

    @include media-breakpoint-down('md') {
        .page-section.collapsible {
            .page-section-collapse {
                display: inline-block;
            }
            &.open {
                .page-section-collapse {
                    margin-top: $spacer-3;
                }
            }
            &:not(.open) {
                .page-section-content {
                    display: none;
                }
            }
        }
    }
    @include media-breakpoint-down('xs') {
        .page-section h3 {
            text-transform: none;
        }
    }
    @include media-breakpoint-down('xs') {
        .page-section {
            padding: $spacer-2;
        }
        .page-section-header ~ .page-section-content {
            margin-top: $spacer-2;
            .page-section-collapse {
                margin-top: $spacer-2;
            }
        }
        .page-section.collapsible.open .page-section-collapse {
            margin-top: $spacer-2;
        }
        .page-section-header .btn-icon {
            font-size: $font-size-base;

            ~ .btn-label {
                display: none;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            title: {type: String, default: null},
            theme: {type: String, default: null},
            collapsible: {type: Boolean, default: false},
            defaultOpen: {type: Boolean, default: false},
            actions: {type: Array, default: () => []},
            component: {type: String, default: null},
            props: {type: Object, default: () => ({})},
            loading: {type: Boolean, default: false},
        },

        data() {
            return {
                isOpen: !this.collapsible || this.defaultOpen,
            };
        },

        computed: {
            classes() {
                let classes = [];
                if (this.isOpen) {
                    classes.push('open');
                }
                if (this.theme !== null) {
                    classes.push(`page-section-${this.theme}`);
                }
                return classes;
            },
            collapseButton() {
                return {
                    icon: this.isOpen ? 'menu-up' : 'menu-down',
                    label: this.isOpen ? 'Weniger anzeigen' : 'Mehr anzeigen',
                };
            },
        },

        methods: {
            mergeActionDefaults(action) {
                return {
                    theme: 'link',
                    size: 'sm',
                    ...action,
                };
            },
        },
    };
</script>